const prefix = 'FACILITY_PAYMENTS_GENERATION';
export const SET_PERIOD = `${prefix}_SET_PERIOD`;
export const SET_PROGRAM_TYPE = `${prefix}_SET_PROGRAM_TYPE`;
export const SET_PROGRAM_PAYMENT_TYPE = `${prefix}_SET_PROGRAM_PAYMENT_TYPE`;
export const GENERATE_PAYMENTS = `${prefix}_GENERATE`;
export const CHECK_PAYMENTS_EXISTENCE = `CHECK_${prefix}_EXISTENCE`;
export const SET_PAYMENTS_EXIST = `${prefix}_EXIST`;
export const GET_PARTNERS = `${prefix}_GET_PARTNERS`;
export const SET_PARTNERS = `${prefix}_SET_PARTNERS`;
export const SET_PARTNER = `${prefix}_SET_PARTNER`;